// src/components/BarChart.jsx

import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import { supabase } from "../Services/supabaseClient";
import { useCompany } from "../context/CompanyContext";

const BarChart = () => {
  const { companyId } = useCompany();
  const [topClients, setTopClients] = useState([]);

  // 1️⃣ Fetch top 3 clients by company
  useEffect(() => {
    if (!companyId) return;

    (async () => {
      const { data, error } = await supabase.rpc("get_top_clients_by_company", {
        p_company_id: companyId,
      });

      if (error) {
        console.error("Error loading top clients:", error);
      } else {
        // expect [{ customer_name, total_revenue }, …]
        setTopClients(
          data.map((row) => ({
            name: row.customer_name,
            revenue: parseFloat(row.total_revenue) || 0,
          }))
        );
      }
    })();
  }, [companyId]);

  // 2️⃣ Initialize / re-initialize the Chart
  useEffect(() => {
    if (topClients.length === 0) return;

    const canvas = document.getElementById("clientsChart");
    // If a Chart instance already exists on this canvas, destroy it
    const existingChart = Chart.getChart(canvas);
    if (existingChart) {
      existingChart.destroy();
    }

    const ctx = canvas.getContext("2d");
    const chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: topClients.map((c) => c.name),
        datasets: [
          {
            label: "Total Revenue",
            data: topClients.map((c) => c.revenue),
            backgroundColor: "rgba(0, 128, 128, 0.6)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 2,
          },
        ],
      },
      options: {
        maintainAspectRatio: true,
        scales: {
          x: {
            title: { display: true, text: "Clients" },
          },
          y: {
            title: { display: true, text: "Total Revenue" },
            beginAtZero: true,
          },
        },
      },
    });

    return () => chart.destroy();
  }, [topClients]);

  return (
    <div style={{ position: "relative", height: "300px" }}>
      <canvas id="clientsChart" />
    </div>
  );
};

export default BarChart;
